import { getPaymentProvider } from './paymentProvider.api';

/**
 * @name getPaymentProviderInfo - to get payment provider details
 * @param {Object} Obj - attributes for the function
 * @param {GraphQL} Obj.graphql - appoloclient graphql constant
 * @param {useState} Obj.setOpenError - useState function which sets error modal
 * @param {useState} Obj.setLoading - useState function which sets the loader
 * @returns {Promise} Resolves in to payment gateway provider
 */
export const getPaymentProviderInfo = async ({
    graphql,
    setProvider,
    setOpenError,
    setLoading,
}) => {
    try {
        const data = await getPaymentProvider({ graphql });
        if (data) {
            setProvider(data?.paymentProvider);
            setLoading(false);
        }
    } catch (error) {
        setOpenError(true);
        setLoading(false);
    }
};
